import { Link, createFileRoute } from '@tanstack/react-router'
import { Button } from '@/components/ui/button'
import { Card } from '@/components/ui/card'

/**
 * Evita loop / ↔ /workspace quando não há VITE_LOGIN_APP_URL e o usuário não está logado.
 */
export const Route = createFileRoute('/(auth)/configuracao-login')({
  component: ConfiguracaoLoginPage,
})

function ConfiguracaoLoginPage() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-100 p-4">
      <Card className="w-full max-w-lg p-8 space-y-4">
        <h1 className="text-xl font-semibold text-slate-900">
          Login do ImobDesk não configurado
        </h1>
        <p className="text-sm text-slate-600 leading-relaxed">
          Defina a variável{' '}
          <code className="rounded bg-slate-200 px-1.5 py-0.5 text-xs">
            VITE_LOGIN_APP_URL
          </code>{' '}
          no <code className="rounded bg-slate-200 px-1.5 py-0.5 text-xs">app/.env</code>{' '}
          com a URL do pacote <code className="rounded bg-slate-200 px-1.5 py-0.5 text-xs">login/</code>{' '}
          (ex.: <code className="rounded bg-slate-200 px-1.5 py-0.5 text-xs">http://localhost:3010</code>
          ), reinicie o Vite e acesse de novo a raiz do app.
        </p>
        <p className="text-sm text-slate-600">
          Sem isso, o app não sabe para onde enviar quem ainda não está autenticado.
        </p>
        <Button asChild variant="outline" size="sm">
          <Link to="/workspace">Ir para workspace (já logado)</Link>
        </Button>
      </Card>
    </div>
  )
}
